import React, { Suspense } from 'react';
import { render } from 'react-dom';
import { Provider as StoreProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'simplebar/dist/simplebar.min.css';
import { App } from './App';
// import { history } from './common/history';
import './common/i18next';
import { store } from './common/store';
import { AppThemeProvider } from './common/theme/theme';
import { Loader } from './components/loader';
import { DialogProvider, SnackbarProvider } from './providers';

render(
  <StoreProvider store={store}>
    <Suspense fallback={<Loader />}>
      <BrowserRouter>
        <AppThemeProvider>
          <DialogProvider>
            <SnackbarProvider>
              <App />
            </SnackbarProvider>
          </DialogProvider>
        </AppThemeProvider>
      </BrowserRouter>
    </Suspense>
  </StoreProvider>,
  document.getElementById('root')
);
